<template>
  <div class="card-body">
    <div class="card-block">
      <div class="card-content">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "volcan-card-content",
  props: ["data"],
  data: function() {
    return {};
  },
  computed: {},
  mounted() {},
  watch: {},
  methods: {}
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// components/AdminTools/card/card-content.vue